module.exports = "/img/family_car.dcaf3402.png";